<template>
  <div>
    <h3 class="text-size-lg-md weight--heavier layout--margin-bottom-lg">
      4. Confirmation
    </h3>
    <div class="account__form-section account__form-section--wide">
      <h4 class="text-size-md weight--bold">You're all set!</h4>
      <p class="layout--margin-top-md">
        <IconCheckmark class="icon icon--green layout--margin-right-xs" />Your
        plan has been successfully changed. Thank you for continuing to use
        Motionmail!
      </p>
      <router-link
        :to="{ name: 'account' }"
        class="button button--big layout--margin-top-lg layout--inline-block"
        >Back to My Account</router-link
      >
    </div>
  </div>
</template>

<script>
import IconCheckmark from "../../../assets/icons/iconCheckmark.svg";
export default {
  name: "confirmation",
  components: {
    IconCheckmark,
  },
};
</script>

<style></style>
